import Section from "./Section";
import Row from "./Row";
import { motion } from "framer-motion";

// ✅ your animations
import { fadeUp, fadeIn, slideLeft, slideRight } from "animations/variants";

const OrderProducts = ({ order }) => {
  const safe = (val, fallback = "-") => val || fallback;

  return (
    <motion.div variants={fadeUp}>
      <Section title="Products">
        <table className="w-full text-left">
          <thead>
            <tr className="border-b text-gray-500">
              <th className="py-3">Product</th>
              <th>Status</th>
              <th>Qty</th>
              <th>Each</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>

          <tbody>
            {order?.orderItems?.map((item) => (
              <motion.tr key={item._id} variants={fadeUp} className="border-b">
                <td className="py-4 flex gap-4">
                  <img
                    src={item?.foodItem?.image || "/fallback.png"}
                    alt="food"
                    className="w-16 h-16 object-cover rounded"
                  />

                  <div>
                    <p className="font-medium">
                      {safe(item?.foodItem?.title || item?.title)}
                    </p>

                    <p className="text-xs text-gray-400">
                      {item?.foodItem?.desc?.slice(0, 60) || ""}
                    </p>
                  </div>
                </td>

                <td className="capitalize text-yellow-600">
                  {safe(order?.orderStatus)}
                </td>

                <td>{safe(item?.qty)}</td>

                <td>${safe(item?.price)}</td>

                <td className="text-right font-medium">
                  ${(item?.price * item?.qty || 0).toFixed(2)}
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>

        {/* TOTAL */}
        <div className="flex justify-end mt-6">
          <div className="w-72 space-y-1">
            <Row label="Subtotal" value={`$${safe(order?.subTotalPrice)}`} />

            <Row label="Tip" value={`$${safe(order?.tip || 0)}`} />
            <Row label="Tax" value={`$${safe(order?.taxprice)}`} />

            <div className="flex justify-between border-t pt-2 font-bold text-red-500">
              <span>Total</span>
              <span>${safe(order?.totalPrice)}</span>
            </div>
          </div>
        </div>
      </Section>
    </motion.div>
  );
};

export default OrderProducts;
